module.exports = __webpack_public_path__ + "static/media/watch_1.02420317.png";